import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NgOptimizedImage } from '@angular/common';
import { AuthService } from '../../../services/auth/auth.service';
import { SharedModule } from '../../../modules/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-header',
  imports: [MatMenuModule, MatIconModule, NgOptimizedImage, SharedModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  public authService = inject(AuthService);
  public _translate = inject(TranslateModule);
  public userProfile = this.authService.getAccountGroups();
  public activeUserRoles = signal<string>('');
  constructor() {
    this.authService.userRoles.subscribe((roles) => {
      if (roles && roles.roles) {
        this.activeUserRoles.set(roles.roles.toString() || '');
      }
    });
  }

  /**
   * Logs out the user by calling the logoutUser method from AuthService.
   *
   * @memberof HeaderComponent
   */
  public logoutUser() {
    this.authService.logoutUser();
  }
}
